<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Aqui você poderá gerenciar e editar as informações do fundo de
              investimentos. Novos investidores e batches podem ser vinculados
              ao fundo a partir de páginas específicas.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--8">
      <div class="row">
        <div class="col-xl-8">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-12">
                  <h3 class="mb-0">
                    Fundo de investimentos
                    <base-button
                      size="sm"
                      type="danger"
                      class="float-right"
                      @click="handleOpenModalremoveConfirmation"
                    >
                      <i class="fas fa-trash mr-1"></i> Deletar fundo
                    </base-button>
                  </h3>
                </div>
              </div>
            </div>
            <template>
              <form
                @submit.prevent
                class="vld-parent"
                ref="form_edit_container"
              >
                <h6 class="heading-small text-muted mb-4">
                  Informações básicas
                </h6>
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col-12">
                      <base-input label="Tipo">
                        <br />
                        <base-radio
                          name="Aceleração"
                          class="mb-3"
                          v-model="model.type"
                          :inline="true"
                        >
                          Aceleração
                        </base-radio>
                        <base-radio
                          name="Pré-aceleração"
                          class="mb-3"
                          v-model="model.type"
                          :inline="true"
                        >
                          Pré-aceleração
                        </base-radio>
                        <base-radio
                          name="Misto"
                          class="mb-3"
                          v-model="model.type"
                          :inline="true"
                        >
                          Misto
                        </base-radio>
                      </base-input>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group has-label">
                        <label
                          class="form-control-label form-control-label-full"
                          >Nome do fundo (tag)
                          <span
                            @click="handleEditTag"
                            class="btn btn-link btn-sm btn-edit pt-0 pb-0 bb-0 border-bottom-0 border-top-0 float-right"
                          >
                            {{ "usar tag padrão" }}
                          </span>
                        </label>
                        <base-input
                          placeholder="Se não editado, será gerado automaticamente"
                          input-classes="form-control"
                          addon-left-icon="ni ni-tag"
                          v-model="model.tag"
                        />
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <label class="form-control-label">
                        Status do fundo
                        <i
                          v-if="model.status"
                          class="fas fa-info-circle ml-1"
                          :title="getStatusDescription"
                        ></i>
                      </label>
                      <div>
                        <base-input addon-left-icon="fas fa-cogs">
                          <select class="form-control" v-model="model.status">
                            <option selected disabled value="">
                              Selecione o status do fundo
                            </option>
                            <option
                              v-for="status in fundStatus"
                              :key="status.key"
                              :value="status.key"
                            >
                              {{ status.value }}
                            </option>
                          </select>
                        </base-input>
                      </div>
                    </div>
                  </div>
                  <estados
                    estadoLabel="Estado origem do fundo (opcional)"
                    cidadeLabel="Cidade origem do fundo"
                    :selectedEstado="model.state"
                    :selectedCidade="model.city"
                    @inputEstado="handleStateChange"
                    @inputCidade="handleCityChange"
                  />
                  <div class="col-lg-12">
                    <div
                      v-show="originalLocation.show"
                      class="col text-sm text-right"
                    >
                      <i class="ni ni-pin-3 mr-1"></i> Localização original:
                      {{ local() }}.
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="form-group has-label">
                        <label class="form-control-label">Data de início</label>
                        <base-input
                          type="date"
                          placeholder="Data fim"
                          input-classes="form-control"
                          addon-left-icon="ni ni-calendar-grid-58"
                          v-model="model.start_date"
                        />
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group has-label">
                        <label class="form-control-label">Data fim</label>
                        <base-input
                          type="date"
                          placeholder="Data fim"
                          input-classes="form-control"
                          addon-left-icon="ni ni-calendar-grid-58"
                          v-model="model.end_date"
                        />
                      </div>
                    </div>
                    <div class="col-12">
                      <span class="duration">
                        {{ calcDuration() }}
                      </span>
                    </div>
                  </div>
                </div>
                <hr class="my-4" />
                <h6 class="heading-small text-muted mb-4">
                  Informações complementares
                </h6>
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col-lg-4">
                      <base-input label="Valor total previsto do fundo">
                        <div class="input-unit-box">
                          <input
                            type="text"
                            placeholder="Valor do fundo"
                            class="form-control input-unit"
                            v-model="model.value"
                          />
                          <span class="unit">R$ </span>
                        </div>
                      </base-input>
                    </div>
                    <div class="col-lg-4">
                      <div class="form-group has-label">
                        <label class="form-control-label"
                          >Número previsto de batches</label
                        >
                        <base-input
                          type="number"
                          placeholder="Número de batches"
                          input-classes="form-control"
                          addon-left-icon="ni ni-money-coins"
                          v-model="model.batches"
                        />
                      </div>
                    </div>
                    <div class="col-lg-4">
                      <div class="form-group has-label">
                        <label class="form-control-label"
                          >Número previsto de investidores</label
                        >
                        <base-input
                          type="number"
                          placeholder="Número de investidores"
                          input-classes="form-control"
                          addon-left-icon="fa fa-user-tie"
                          v-model="model.number_investors"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 mt-2">
                      <i class="fas fa-user fa-sm mr-2"></i>
                      <span>Investidores registrados no fundo: </span>
                      <badge type="info" class="p-2">{{
                        count.investors || 0
                      }}</badge>
                      <base-button
                        type="secondary"
                        @click="
                          $router.push(
                            `/admin/fundos/${$route.params.id}/investidores`
                          )
                        "
                        size="sm"
                        class="float-right"
                        :custom="true"
                        >Gerenciar investidores</base-button
                      >
                    </div>
                    <div class="col-12 mt-2">
                      <i class="fas fa-award fa-sm mr-2"></i>
                      <span>Batches registrados no fundo: </span>
                      <badge type="info" class="p-2">{{
                        count.batches || 0
                      }}</badge>
                      <base-button
                        type="secondary"
                        @click="
                          $router.push(
                            `/admin/fundos/${$route.params.id}/batches`
                          )
                        "
                        size="sm"
                        class="float-right"
                        :custom="true"
                        >Gerenciar batches</base-button
                      >
                    </div>
                  </div>
                </div>
                <hr class="my-4" />
                <!-- Description -->
                <div class="pl-lg-4">
                  <div class="form-group">
                    <base-input label="Descrição (opicional)">
                      <textarea
                        rows="3"
                        class="form-control form-control"
                        placeholder="Digite aqui..."
                        v-model="model.description"
                      >
                      </textarea>
                    </base-input>
                  </div>
                </div>
              </form>
            </template>
          </card>
        </div>
        <div class="col-xl-4 order-xl-1 mb-5 mb-xl-0 mt-6 mt-lg-0">
          <div class="card card-profile shadow">
            <div class="row justify-content-center">
              <div class="col-lg-3 order-lg-2">
                <div class="card-profile-image">
                  <img src="/img/pages/fund.png" class="rounded-circle" />
                </div>
              </div>
            </div>
            <div class="card-header text-center border-0">
              <div class="d-flex justify-content-between"></div>
            </div>
            <div class="card-body pt-5 pt-md-4 pb-4">
              <div class="row">
                <div class="col">
                  <div
                    class="card-profile-stats d-flex justify-content-center mt-md-5"
                  >
                    <div>
                      <span class="heading">{{ model.batches || "-" }}</span>
                      <span class="description">Batches</span>
                    </div>
                    <div>
                      <span class="heading">{{
                        formatValue(model.value)
                      }}</span>
                      <span class="description">Valor</span>
                    </div>
                    <div>
                      <span class="heading">{{
                        model.number_investors || "-"
                      }}</span>
                      <span class="description">Investidores</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-center">
                <h3>
                  Cidade: <span class="font-weight-light"> {{ local() }}</span>
                </h3>
                <h3>
                  Fundo válido de:
                  <span class="font-weight-light">
                    {{ getYear(this.model.start_date) }} até
                    {{ getYear(this.model.end_date) }}
                  </span>
                </h3>
                <hr class="my-4" />
                <h2 class="text-center tag-title">
                  <i class="ni ni-tag"></i>
                  <span class="tag">{{ model.tag || tag() }}</span>
                </h2>
                <div class="col-12 text-center" v-if="error">
                  <base-alert type="danger">{{ error }}</base-alert>
                </div>
                <div class="col-12 text-center" v-if="success">
                  <base-alert type="success">{{ success }}</base-alert>
                </div>
                <base-button
                  type="primary"
                  @click="handleSubmit"
                  size="md"
                  :custom="true"
                  >Salvar alterações</base-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal
      :show.sync="modals.removeConfirmation"
      gradient="dark"
      modal-classes="modal-danger modal-dialog-centered"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Atenção!
      </h6>
      <div class="vld-parent" ref="modal_confirmation_delete">
        <div class="py-3 text-center">
          <i class="fa fa-exclamation-circle fa-3x"></i>
          <h4 class="heading mt-4">
            Você realmente deseja excluir o fundo
            <span class="text-danger">{{ model.tag }}</span
            >?
          </h4>
          <p class="mt-3 mb-0">
            Se existirem, todas as chamadas, batches e avalições avaliações
            cadastradas a esse fundo serão perdidas.
          </p>
          <p class="mt-3">
            Por favor, digite
            <span class="text-warning font-weight-bold">{{ model.tag }}</span>
            para prosseguir
          </p>
          <base-input
            placeholder="Digite aqui"
            input-classes="form-control"
            addon-left-icon="fas fa-trash text-warning"
            v-model="modals.inputConfirmation"
          />
        </div>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="white"
          class="ml-auto"
          @click="modals.removeConfirmation = false"
        >
          Voltar
        </base-button>
        <base-button
          type="white"
          class="text-danger"
          @click="handleDeleteFund"
          :disabled="!inputConfirmationTextIsValid()"
        >
          Confirmar exclusão
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import api from "@/services/api.js";

export default {
  name: "fundo",
  data() {
    return {
      model: {
        id: "",
        type: "",
        tag: "",
        state: "",
        city: "",
        start_date: "",
        end_date: "",
        value: "",
        batches: "",
        number_investors: "",
        description: "",
        status: "",
      },
      count: {
        investors: 0,
        batches: 0,
      },
      fundStatus: [
        {
          key: "open",
          value: "Regular",
          description:
            "Um fundo regular fica visível para os investidores cadastrados no fundo.",
        },
        {
          key: "closed",
          value: "Encerrado",
          description:
            "O status 'Encerrado' ficará visível para os investidores cadastrados no fundo.",
        },
        {
          key: "hidden",
          value: "Invisível",
          description:
            "Um fundo invisível fica oculto para todos os investidores.",
        },
      ],
      originalLocation: {
        show: false,
        state: "",
        city: "",
      },
      state: "",
      city: "",
      editTag: false,
      error: "",
      success: "",
      modals: {
        removeConfirmation: false,
        inputConfirmation: "",
      },
    };
  },
  async mounted() {
    const loader = this.$loading.show({
      container: this.$refs.form_edit_container,
      width: 140,
      height: 140,
    });
    try {
      const { data } = await api.get(`/funds/${this.$route.params.id}`);
      this.originalLocation.state = data.state;
      this.originalLocation.city = data.city;
      this.count.investors = data.number_current_investors;
      this.count.batches = data.number_current_batches;
      delete data.number_current_investors;
      delete data.number_current_batches;
      const model = this.model;
      Object.keys(data).forEach(function (key) {
        if (key in model) model[key] = data[key];
      });
    } catch (e) {
      this.$toasted.error("Ocorreu ao recuperar as informações do fundo");
      this.$router.push("/admin/fundos");
    }
    loader.hide();
  },
  methods: {
    async handleSubmit(e) {
      e.preventDefault();
      this.error = this.success = "";
      const data = Object.assign({}, this.model);
      if (!data.state) {
        data.state = this.originalLocation.state;
        data.city = this.originalLocation.city;
      }
      if (!data.description) data.description = "N/A";
      for (var key in data) {
        if (data[key] === "") {
          this.error =
            "Por favor, preencha todos os campos antes de continuar.";
          return;
        }
      }
      const loader = this.$loading.show({
        container: this.$refs.form_edit_container,
        width: 160,
        height: 160,
      });
      try {
        await api.put(`/funds/${data.id}`, data);
        this.$toasted.show("Fundo atualizado com sucesso");
        this.success = "As informações do fundo foram atualizadas com sucesso.";
      } catch (e) {
        this.error =
          "Ocorreu um erro ao atualizar o fundo. Verifique as informações e tente novamente.";
        this.$toasted.error("Ocorreu um erro ao salvar as informações");
      } finally {
        loader.hide();
      }
    },
    local() {
      return `${this.originalLocation.city}, ${this.originalLocation.state}`;
    },
    handleEditTag() {
      if ((this.model.state && this.model.city) || !this.model.state)
        this.model.tag = this.tag();
      else this.model.tag = "Estado modificado, selecione uma cidade";
    },
    calcDuration() {
      if (this.model.start_date && this.model.end_date) {
        const d1 = this.moment(this.model.start_date);
        const d2 = this.moment(this.model.end_date);
        let diffDays = d2.diff(d1, "days");
        if (diffDays <= 0) return "Data fim deve ser maior que data de início";
        return `* Validade do fundo: ${diffDays} dias`;
      }
    },
    tag() {
      let prefixType, prefixCity, start_dateYear;
      if (this.model.type) {
        if (this.model.type === "Aceleração") prefixType = "ACEL";
        else if (this.model.type === "Pré-aceleração") prefixType = "PRE_ACEL";
        else prefixType = "MISTO";
      }
      if (this.model.city || this.originalLocation.city) {
        const selectedCity = this.model.city
          ? this.model.city
          : this.originalLocation.city;
        prefixCity = selectedCity
          .replace(/ /g, "")
          .substring(0, 3)
          .toUpperCase();
        //.map(w => w.charAt(0).toUpperCase())
        // .join("");
      }
      if (this.model.start_date)
        start_dateYear = this.getYear(this.model.start_date);
      return [
        prefixType,
        prefixCity,
        this.model.state || this.originalLocation.state,
        start_dateYear,
      ]
        .filter(Boolean) // w => w != null
        .join("_");
    },
    handleStateChange(newState) {
      this.model.state = newState;
      this.originalLocation.show = true;
    },
    handleCityChange(newCity) {
      this.model.city = newCity;
      this.originalLocation.show = true;
    },
    handleOpenModalremoveConfirmation() {
      this.modals.removeConfirmation = true;
      this.modals.inputConfirmation = "";
    },
    inputConfirmationTextIsValid() {
      return this.modals.inputConfirmation === this.model.tag;
    },
    async handleDeleteFund() {
      const loader = this.$loading.show({
        container: this.$refs.modal_confirmation_delete,
        width: 160,
        height: 160,
        opacity: 0,
      });
      try {
        await api.delete(`/funds/${this.$route.params.id}`);
        this.$toasted.show("Fundo removido com sucesso");
        this.$router.push({ name: "admin_fundos" });
      } catch (e) {
        this.error = "Ocorreu um erro ao remover o fundo.";
        this.$toasted.error("Ocorreu um erro ao remover o fundo.");
      } finally {
        loader.hide();
      }
    },
  },
  computed: {
    getStatusDescription() {
      const selectedStatus = this.fundStatus.find(
        (status) => status.key === this.model.status
      );
      return selectedStatus ? selectedStatus.description : "";
    },
  },
};
</script>
<style scoped>
.input-unit-box {
  position: relative;
}

.form-control-label-full {
  width: 100%;
}

.input-unit {
  display: block;
  border: 1px solid #d7d6d6;
  background: #fff;
  padding: 10px 10px 10px 30px;
}

.unit {
  position: absolute;
  display: block;
  left: 5px;
  top: 10px;
  z-index: 9;
  color: #444444;
}

.duration,
.quota {
  font-size: 12px;
  color: #444444;
  text-transform: uppercase;
}

.duration,
.quota,
.tag {
  font-family: inherit;
  font-weight: 600;
  line-height: 1.5;
}

.tag {
  font-size: 18px;
  margin-left: 1em;
  color: black;
}

.tag-title {
  margin-bottom: 1.2em;
}
</style>
